module.exports = __webpack_public_path__ + "static/img/aliPay.fa99c226.png";